import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type LoaderMode = 'inline' | 'overlay' | 'fullscreen';

@Component({
  selector: 'app-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="three-body" aria-hidden="true">
      <div class="three-body__dot"></div>
      <div class="three-body__dot"></div>
      <div class="three-body__dot"></div>
    </div>
  `,
  styleUrl: './loader.component.scss',
  host: {
    role: 'status',
    'aria-live': 'polite',
    'aria-label': 'Loading',
    '[class.loader--overlay]': "mode() === 'overlay'",
    '[class.loader--fullscreen]': "mode() === 'fullscreen'",
    '[style.--loader-size]': "size() + 'px'",
  },
})
export class LoaderComponent {
  /** `overlay` covers the nearest positioned ancestor; `fullscreen` covers the viewport. */
  readonly mode = input<LoaderMode>('inline');
  readonly size = input(35);
}
